import { useQuery } from '@apollo/client';
import { GetIssueAssessmentAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { getAuditItems } from './auditEntityFinder';
import AuditViewComponent from './AuditViewComponent';
import type { AuditEntityRetrieverInput } from './types';

const IssueAssessmentAudit = (input: AuditEntityRetrieverInput) => {
  const { data: result } = useQuery(GetIssueAssessmentAuditByIdDocument, {
    variables: {
      Id: input.id,
    },
  });

  const { current, previous } = getAuditItems(
    result?.issue_assessment_audit,
    input.operationDate
  );

  return (
    <AuditViewComponent
      operation={input.operation}
      current={JSON.stringify(current, null, 2)}
      previous={JSON.stringify(previous, null, 2)}
    />
  );
};

export default IssueAssessmentAudit;
